import { useEffect } from "react";

function upsert(sel, create) {
  let el = document.head.querySelector(sel);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
}

export default function Seo({ title, description, locale = "en", path = "", altPath, image, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
    const origin = window.location.origin;

    const meta = (name, content, attr = "name") => {
      if (!content) return;
      const el = upsert(`meta[${attr}="${name}"]`, () => {
        const m = document.createElement("meta");
        m.setAttribute(attr, name);
        return m;
      });
      el.setAttribute("content", content);
    };

    meta("description", description);
    meta("og:title", title, "property");
    meta("og:description", description, "property");
    meta("og:type", "website", "property");
    meta("og:url", `${origin}${path}`, "property");
    meta("og:site_name", "Studio Movies IA", "property");
    if (image) meta("og:image", image, "property");
    meta("twitter:card", "summary_large_image");
    meta("twitter:title", title);
    meta("twitter:description", description);
    if (image) meta("twitter:image", image);

    const canonical = upsert('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.rel = "canonical";
      return l;
    });
    canonical.href = `${origin}${path}`;

    document.head.querySelectorAll('link[data-hreflang="1"]').forEach((n) => n.remove());
    if (altPath) {
      const other = locale === "en" ? "fr" : "en";
      [[locale, path], [other, altPath], ["x-default", path]].forEach(([lang, href]) => {
        const l = document.createElement("link");
        l.rel = "alternate";
        l.hreflang = lang;
        l.href = `${origin}${href}`;
        l.setAttribute("data-hreflang", "1");
        document.head.appendChild(l);
      });
    }

    document.head.querySelectorAll('script[data-jsonld="1"]').forEach((n) => n.remove());
    const blocks = [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Studio Movies IA",
        url: origin,
        email: "studiomoviesia@gmail.com",
        description: "AI film production studio for cinematic images, videos and long-form films.",
      },
      {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        name: "Studio Movies IA",
        applicationCategory: "MultimediaApplication",
        operatingSystem: "Web, iOS, Android",
        offers: { "@type": "Offer", price: "0", priceCurrency: "EUR" },
      },
      ...(jsonLd ? [jsonLd] : []),
    ];
    blocks.forEach((b) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-jsonld", "1");
      s.textContent = JSON.stringify(b);
      document.head.appendChild(s);
    });
  }, [title, description, locale, path, altPath, image, jsonLd]);

  return null;
}
